import type React from 'react'
import {Accordion as PepsicoAccordion} from 'pepsico-ds'
import type {IAccordionV2Props} from 'pepsico-ds'

// Wrapper component for Pepsico DS Accordion
const Accordion: React.FC<IAccordionV2Props> = props => {
  return <PepsicoAccordion {...props} />
}

export default Accordion
